"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationSeverity = exports.Label = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireWildcard(require("../Button"));

var _utils = require("../../utils");

var _excluded = ["actions", "borderless", "children", "className", "close", "inline", "onDismiss", "severity", "status", "timeout", "timestamp", "title", "type"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Label;
exports.Label = Label;

(function (Label) {
  Label["Close"] = "Close notification";
})(Label || (exports.Label = Label = {}));

var NotificationSeverity = {
  CAUTION: "caution",
  INFORMATION: "information",
  NEGATIVE: "negative",
  POSITIVE: "positive"
};
exports.NotificationSeverity = NotificationSeverity;

var Notification = function Notification(_ref) {
  var _classNames;

  var actions = _ref.actions,
      _ref$borderless = _ref.borderless,
      borderless = _ref$borderless === void 0 ? false : _ref$borderless,
      children = _ref.children,
      className = _ref.className,
      close = _ref.close,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      onDismiss = _ref.onDismiss,
      _ref$severity = _ref.severity,
      severity = _ref$severity === void 0 ? NotificationSeverity.INFORMATION : _ref$severity,
      status = _ref.status,
      timeout = _ref.timeout,
      timestamp = _ref.timestamp,
      title = _ref.title,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, _excluded);

  var timeoutId = (0, _react.useRef)(null);
  var hasActions = (actions === null || actions === void 0 ? void 0 : actions.length) > 0;
  var showMeta = !!timestamp || hasActions;
  (0, _react.useEffect)(function () {
    if (timeout && onDismiss) {
      timeoutId.current = setTimeout(function () {
        return onDismiss();
      }, timeout);
    }

    return function () {
      return clearTimeout(timeoutId.current);
    };
  }, [onDismiss, timeout]);

  if (_utils.IS_DEV && (close || status || type)) {
    console.warn("The Notification component is using deprecated props. Refer to the deprecated list for details: https://canonical.github.io/react-components/?path=/docs/notification--information#deprecated");
  }

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(className, (_classNames = {}, _defineProperty(_classNames, "p-notification--".concat(severity), !!severity), _defineProperty(_classNames, "p-notification", !severity), _defineProperty(_classNames, "is-borderless", borderless), _defineProperty(_classNames, "is-inline", inline), _classNames))
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "p-notification__content"
  }, title && /*#__PURE__*/_react.default.createElement("h5", {
    className: "p-notification__title",
    "data-testid": "notification-title"
  }, title), inline && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\u2002"), /*#__PURE__*/_react.default.createElement("p", {
    className: "p-notification__message"
  }, children), onDismiss && /*#__PURE__*/_react.default.createElement("button", {
    className: "p-notification__close",
    "data-testid": "notification-close-button",
    onClick: onDismiss
  }, Label.Close)), showMeta && /*#__PURE__*/_react.default.createElement("div", {
    className: "p-notification__meta",
    "data-testid": "notification-meta"
  }, timestamp && /*#__PURE__*/_react.default.createElement("span", {
    className: "p-notification__timestamp",
    "data-testid": "notification-timestamp"
  }, timestamp), hasActions ? /*#__PURE__*/_react.default.createElement("div", {
    className: "p-notification__actions"
  }, actions.map(function (action, i) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      appearance: _Button.ButtonAppearance.LINK,
      className: "p-notification__action",
      "data-testid": "notification-action",
      key: "".concat(action.label, "-").concat(i),
      onClick: action.onClick
    }, action.label);
  })) : null));
};

var _default = Notification;
exports.default = _default;